// extracted by mini-css-extract-plugin
export default {"container":"LockScreen-module__container","wrapper":"LockScreen-module__wrapper","icon":"LockScreen-module__icon","help":"LockScreen-module__help"};